import React from 'react';
import { Github } from '@dragonchain-dev/dragon-kit-icons';
import { Title } from '../Title';
import { SdkPanel } from '../SdkPanel';

var DeveloperNavPanel = function DeveloperNavPanel() {
  return /*#__PURE__*/React.createElement("div", {
    className: "subnav-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "inner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title-icon"
  }, /*#__PURE__*/React.createElement(Github, null)), /*#__PURE__*/React.createElement(Title, {
    tag: "div"
  }, "Dragonchain SDK"), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, "Work with your Dragonchain API using official Dragonchain SDKs, now available for Node.js and Python."), /*#__PURE__*/React.createElement(SdkPanel, null)));
};

DeveloperNavPanel.displayName = 'DeveloperNavPanel';
var DeveloperNavPanelDoc;

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  DeveloperNavPanelDoc = require('./doc').doc(DeveloperNavPanel);
}

var DeveloperNavPanelWrapper = DeveloperNavPanelDoc || DeveloperNavPanel;
export { DeveloperNavPanelWrapper as DeveloperNavPanel };